const log = window.log;

$(document).ready(function () {
  if (log) log.collapse({
    localizationEnabled: !!window.localizationEnabled,
    localeRedirect: window.localeRedirect ? { currentStoreId: window.localeRedirect.currentStoreId, euStoreId: window.localeRedirect.euStoreId, usaStoreId: window.localeRedirect.usaStoreId } : null,
    designMode: !!(window.Shopify && window.Shopify.designMode)
  }, 'Localization init config', 'info');

  // ===================== Theme customizer guard =====================
  function isShopifyDesignMode() {
    try {
      return !!(window.Shopify && window.Shopify.designMode);
    } catch (e) {
      return false;
    }
  }

  function shouldSkipStoreRedirectForDev() {
    try {
      const themeRole = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if (themeRole === 'development' || themeRole === 'unpublished') return true;
      const host = window.location.hostname;
      const port = window.location.port;
      if (host === 'localhost') return true;
      if (host === '127.0.0.1' && port === '9292') return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  // ===================== Crawler / Bot Guard =====================
  function shouldSkipRedirectForBots() {
    try {
      const ua = (navigator.userAgent || '').toLowerCase();
      const isWebDriver = !!navigator.webdriver;
      const isHeadless = /(headless|phantomjs|puppeteer|playwright)/i.test(ua);
      const isBot =
        /(googlebot|adsbot|adsbot-google|textadsbot-google|mediapartners-google|google-adwords|feedfetcher-google|apis-google|storebot-google|googleproducer|bingbot|slurp|duckduckbot|baiduspider|yandexbot|sogou|exabot|facebot|facebookexternalhit|twitterbot|pinterestbot|linkedinbot|slackbot|telegrambot|whatsapp|applebot)/i.test(
          ua
        );
      return isWebDriver || isBot || isHeadless;
    } catch (e) {
      return false;
    }
  }

  // ===================== Theme preview guard =====================
  // Previewing an unpublished theme: the /localization redirect lands on the primary domain, where the preview
  // session does not apply, so the visitor ends up on the live theme. Language redirects only run on the live theme.
  function isThemePreview() {
    try {
      const role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      return !!role && role !== 'main';
    } catch (e) {
      return false;
    }
  }

  function shouldSkipEuLocalization() {
    return isShopifyDesignMode() || shouldSkipRedirectForBots() || isThemePreview();
  }

  // ===================== Cookie Management =====================
  function getCookie(name) {
    const cookies = document.cookie.split(';');
    const cookieObj = {};
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie) {
        const [key, value] = cookie.split('=');
        if (key) {
          cookieObj[key.trim()] = value ? decodeURIComponent(value.trim()) : '';
        }
      }
    }
    const val = cookieObj[name] || null;
    if (log && (name === 'RedirectedFirstTime' || name === 'userSelectedLanguage')) {
      log.collapse({ [name]: val }, 'getCookie ' + name, 'info');
    }
    return val;
  }

  function setCookie(name, value, days = 30) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
  }

  // ===================== Locale path helpers (from Liquid: window.localizationLanguages) =====================
  function getLocalizationLanguages() {
    const langs = window.localizationLanguages;
    return Array.isArray(langs) ? langs : [];
  }

  function getCountryRows() {
    const rows = window.localizationGeoCountrySuggestions;
    return Array.isArray(rows) ? rows : [];
  }

  function getLocalizationDefaults() {
    const defaults = window.localizationDefaults;
    if (!defaults || typeof defaults !== 'object') {
      return { country: 'DE', locale: 'en' };
    }
    return {
      country: String(defaults.country || 'DE').toUpperCase().trim(),
      locale: String(defaults.locale || 'en').split('-')[0].toLowerCase().trim()
    };
  }

  function normalizeLocaleBase(value) {
    return String(value || '')
      .split('-')[0]
      .toLowerCase()
      .trim();
  }

  function getDefaultLocaleIso() {
    const langs = getLocalizationLanguages();
    const primary = langs.find((l) => l && (l.primary === true || !l.prefix));
    if (primary && primary.iso) return normalizeLocaleBase(primary.iso);
    if (langs[0] && langs[0].iso) return normalizeLocaleBase(langs[0].iso);
    return getLocalizationDefaults().locale;
  }

  function isLocaleAvailableOnStore(localeBase) {
    const b = normalizeLocaleBase(localeBase);
    if (!b) return false;
    const langs = getLocalizationLanguages();
    if (!langs.length) return /^[a-z]{2}$/.test(b);
    return langs.some((l) => l && normalizeLocaleBase(l.iso) === b);
  }

  function resolveStoreLocaleForUrl(suggestedBase) {
    const base = normalizeLocaleBase(suggestedBase);
    if (!base) return null;
    const langs = getLocalizationLanguages();
    const hit = langs.find((l) => l && normalizeLocaleBase(l.iso) === base);
    if (hit && hit.iso) return normalizeLocaleBase(hit.iso);
    return base;
  }

  function getSuggestedLocaleForCountry(countryCodeUpper) {
    const cc = String(countryCodeUpper || '')
      .toUpperCase()
      .trim();
    const rows = getCountryRows();
    if (!cc) return null;
    const hit = rows.find((r) => r && String(r.country).toUpperCase() === cc);
    const loc = hit && hit.locale ? normalizeLocaleBase(hit.locale) : '';
    return loc || null;
  }

  function isCountryAvailable(countryCodeUpper) {
    const cc = String(countryCodeUpper || '')
      .toUpperCase()
      .trim();
    if (!cc) return false;
    return getCountryRows().some((r) => r && String(r.country).toUpperCase() === cc);
  }

  function resolveCountryFromGeo(countryCodeUpper) {
    const cc = String(countryCodeUpper || '')
      .toUpperCase()
      .trim();
    if (cc && isCountryAvailable(cc)) return cc;
    return getLocalizationDefaults().country;
  }

  function resolveLocaleForCountry(countryCodeUpper) {
    const cc = String(countryCodeUpper || '')
      .toUpperCase()
      .trim();
    const suggested = getSuggestedLocaleForCountry(cc);
    if (suggested) return resolveStoreLocaleForUrl(suggested);
    return resolveStoreLocaleForUrl(getLocalizationDefaults().locale);
  }

  function getCurrentCountryCode() {
    const urlCountry = new URLSearchParams(window.location.search).get('country');
    if (urlCountry) {
      return String(urlCountry).toUpperCase().trim();
    }
    const serverCountry = window.localizationCurrentCountry;
    if (serverCountry) {
      return String(serverCountry).toUpperCase().trim();
    }
    return '';
  }

  function stripLocalePrefixesFromPathname(pathname) {
    const langs = getLocalizationLanguages();
    if (!langs.length) {
      let p = pathname;
      while (p.match(/^\/[a-z]{2}(\/|$)/)) {
        p = p.replace(/^\/[a-z]{2}(\/|$)/, '/');
      }
      if (p === '' || p === '/') return '/';
      return p;
    }
    const prefixes = langs
      .map((l) => (l && l.prefix ? String(l.prefix) : ''))
      .filter(Boolean)
      .sort((a, b) => b.length - a.length);
    let p = pathname;
    for (const pref of prefixes) {
      if (p === pref || p === pref + '/') {
        return '/';
      }
      if (p.startsWith(pref + '/')) {
        const next = p.slice(pref.length);
        return next === '' ? '/' : next;
      }
    }
    if (p === '' || p === '/') return '/';
    return p;
  }

  function stripTrailingSlashOrigin(url) {
    if (!url) return '';
    return String(url).replace(/\/+$/, '');
  }

  function getCrossStoreOriginForId(storeId) {
    const cfg = window.localeRedirect;
    const pub = window.localizationPublicOrigins;
    const id = String(storeId || '')
      .trim()
      .toLowerCase();
    if (pub && cfg) {
      const eu = String(cfg.euStoreId || '')
        .trim()
        .toLowerCase();
      const usa = String(cfg.usaStoreId || '')
        .trim()
        .toLowerCase();
      if (id === eu && pub.eu) return stripTrailingSlashOrigin(pub.eu);
      if (id === usa && pub.usa) return stripTrailingSlashOrigin(pub.usa);
    }
    return 'https://' + String(storeId || '').trim() + '.myshopify.com';
  }

  function normalizeStoreRedirectPath(path) {
    const raw = String(path || '/').trim();
    if (!raw || raw === '/') return '/';
    return raw.startsWith('/') ? raw : '/' + raw;
  }

  function getPreservedQueryString() {
    const params = new URLSearchParams(window.location.search);
    params.delete('country');
    params.delete('locale');
    params.delete('redirect');
    const qs = params.toString();
    return qs ? '?' + qs : '';
  }

  function isStoreRedirectDisabled() {
    const params = new URLSearchParams(window.location.search);
    return String(params.get('redirect') || '').toLowerCase() === 'off';
  }

  function appendRedirectOffToUrl(url) {
    if (!isStoreRedirectDisabled()) return url;
    try {
      const parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) return url;
      if (String(parsed.searchParams.get('redirect') || '').toLowerCase() === 'off') return url;
      parsed.searchParams.set('redirect', 'off');
      if (url.startsWith('/') && !url.startsWith('//')) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }

  function preserveRedirectOffOnLinks() {
    if (!isStoreRedirectDisabled()) return;
    const links = document.querySelectorAll('a[href]');
    for (const link of links) {
      const href = link.getAttribute('href');
      if (!href) continue;
      if (
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('javascript:')
      ) {
        continue;
      }
      const nextHref = appendRedirectOffToUrl(href);
      if (nextHref !== href) {
        link.setAttribute('href', nextHref);
      }
    }
  }

  function buildCrossStoreRedirectUrl(storeId, redirectPath) {
    const base = getCrossStoreOriginForId(storeId);
    const path = normalizeStoreRedirectPath(redirectPath);
    return base + (path === '/' ? '' : path) + getPreservedQueryString();
  }

  function resolveLocaleTag(localeBase) {
    const base = normalizeLocaleBase(localeBase);
    const langs = getLocalizationLanguages();
    const hit = langs.find((l) => l && normalizeLocaleBase(l.iso) === base);
    if (hit && hit.isoTag) return String(hit.isoTag);
    return base;
  }

  function buildLocalizedPath(localeBase) {
    const defaultIso = getDefaultLocaleIso();
    const targetLang = normalizeLocaleBase(localeBase) || defaultIso;
    let currentPath = stripLocalePrefixesFromPathname(window.location.pathname);
    if (currentPath === '' || currentPath === '/') {
      currentPath = '/';
    }
    if (targetLang && targetLang !== defaultIso) {
      return currentPath === '/' ? '/' + targetLang : '/' + targetLang + currentPath;
    }
    return currentPath;
  }

  function buildReturnTo(localeBase, preserveParams = true) {
    const path = buildLocalizedPath(localeBase);
    if (!preserveParams) return path;
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('country');
    urlParams.delete('locale');
    const queryString = urlParams.toString();
    return path + (queryString ? '?' + queryString : '');
  }

  function submitLocalizationForm(localeBase, countryCode, preserveParams = true) {
    if (shouldSkipEuLocalization()) return;

    const localeTag = resolveLocaleTag(localeBase);
    const country = countryCode ? String(countryCode).toUpperCase().trim() : '';
    const returnTo = buildReturnTo(localeBase, preserveParams);
    const action = window.localizationFormAction || '/localization';

    const form = document.createElement('form');
    form.method = 'post';
    form.action = action;
    form.setAttribute('accept-charset', 'UTF-8');
    form.hidden = true;

    const fields = {
      form_type: 'localization',
      utf8: '✓',
      _method: 'PUT',
      locale_code: localeTag,
      return_to: returnTo
    };
    if (country) {
      fields.country_code = country;
    }

    for (const [name, value] of Object.entries(fields)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    document.body.appendChild(form);
    if (log) {
      log.collapse({ localeTag, country, returnTo, action }, 'Localization form submit', 'info');
    }
    form.submit();
  }

  function markGeoLocalizationDone() {
    setCookie('RedirectedFirstTime', '1', 30);
  }

  function getCurrentLanguageFromPath() {
    if (window.localizationCurrentLocale) return normalizeLocaleBase(window.localizationCurrentLocale);
    const path = window.location.pathname;
    const langs = getLocalizationLanguages();
    if (langs.length) {
      const sorted = [...langs].sort((a, b) => (b.prefix || '').length - (a.prefix || '').length);
      for (const l of sorted) {
        const pref = l.prefix ? String(l.prefix) : '';
        if (!pref) continue;
        if (path === pref || path === pref + '/' || path.startsWith(pref + '/')) {
          return normalizeLocaleBase(l.iso);
        }
      }
      return getDefaultLocaleIso();
    }
    const match = path.match(/^\/([a-z]{2})(\/|$)/);
    return match ? match[1].toLowerCase() : getDefaultLocaleIso();
  }

  function isLocalizationContextMatch(targetLocale, targetCountry) {
    const currentLanguage = getCurrentLanguageFromPath();
    const currentCountry = getCurrentCountryCode();
    const normalizedTargetLocale = normalizeLocaleBase(targetLocale);
    const normalizedTargetCountry = String(targetCountry || '').toUpperCase().trim();

    if (normalizedTargetLocale !== currentLanguage) return false;
    if (!normalizedTargetCountry) return true;
    return normalizedTargetCountry === currentCountry;
  }

  function applyGeoLocalization(countryCodeUpper) {
    let geoCountry = String(countryCodeUpper || '').toUpperCase().trim();
    if (!geoCountry) {
      geoCountry = getCurrentCountryCode();
    }
    const targetCountry = resolveCountryFromGeo(geoCountry);
    const targetLocale = resolveLocaleForCountry(targetCountry);

    if (!isLocaleAvailableOnStore(targetLocale)) {
      if (log) log.collapse({ targetLocale, targetCountry }, 'Geo localization skip (locale not on store)', 'warning');
      markGeoLocalizationDone();
      return;
    }

    if (isLocalizationContextMatch(targetLocale, targetCountry)) {
      if (log) log.collapse({ targetLocale, targetCountry }, 'Geo localization skip (already matched)', 'info');
      markGeoLocalizationDone();
      return;
    }

    if (log) {
      log.collapse(
        {
          geoCountryRaw: countryCodeUpper,
          geoCountryResolved: geoCountry,
          targetCountry,
          targetLocale,
          currentLanguage: getCurrentLanguageFromPath(),
          currentCountry: getCurrentCountryCode()
        },
        'Geo localization form submit',
        'info'
      );
    }

    markGeoLocalizationDone();
    submitLocalizationForm(targetLocale, targetCountry, true);
  }

  // ===================== EU / USA Store Redirect =====================
  function applyStoreRedirectForCountry(cc, cfg, isUsaStore, isEuStore) {
    if (isUsaStore && cc !== 'US') {
      const target = buildCrossStoreRedirectUrl(cfg.euStoreId.trim(), cfg.euRedirectPath);
      if (log) log.collapse({ cc, isUsaStore, action: 'redirect→EU', target, redirectPath: cfg.euRedirectPath }, 'Store redirect', 'info');
      location.href = target;
      return true;
    }
    if (isEuStore && cc === 'US') {
      const target = buildCrossStoreRedirectUrl(cfg.usaStoreId.trim(), cfg.usaRedirectPath);
      if (log) log.collapse({ cc, isEuStore, action: 'redirect→USA', target, redirectPath: cfg.usaRedirectPath }, 'Store redirect', 'info');
      location.href = target;
      return true;
    }
    if (log) log.collapse({ cc, isUsaStore, isEuStore, action: 'none' }, 'Store redirect no redirect', 'info');
    return false;
  }

  function initStoreRedirect(onDone) {
    if (isShopifyDesignMode()) {
      if (log) log.collapse({ action: 'skip store redirect (design mode)' }, 'Store redirect skip (customizer)', 'info');
      if (onDone) onDone();
      return;
    }
    if (shouldSkipStoreRedirectForDev()) {
      if (log) log.collapse({ action: 'skip store redirect (dev)' }, 'Store redirect skip (dev environment)', 'info');
      if (onDone) onDone();
      return;
    }
    if (shouldSkipRedirectForBots()) {
      if (log) log.collapse({ action: 'skip store redirect (bot)' }, 'Store redirect skip (crawler)', 'info');
      if (onDone) onDone();
      return;
    }
    if (isStoreRedirectDisabled()) {
      if (log) log.collapse({ action: 'skip store redirect (redirect=off)' }, 'Store redirect skip (manual override)', 'info');
      if (onDone) onDone();
      return;
    }
    const cfg = window.localeRedirect;
    const missing = !cfg || !cfg.euStoreId || !cfg.usaStoreId || !cfg.currentStoreId;
    if (missing) {
      if (log) log.collapse({ missing, cfg: cfg ? { hasEu: !!cfg.euStoreId, hasUsa: !!cfg.usaStoreId, hasCurrent: !!cfg.currentStoreId } : null }, 'Store redirect skip (config)', 'info');
      if (onDone) onDone();
      return;
    }
    const eu = String(cfg.euStoreId).trim().toLowerCase();
    const usa = String(cfg.usaStoreId).trim().toLowerCase();
    const cur = String(cfg.currentStoreId).trim().toLowerCase();
    const isUsaStore = cur === usa;
    const isEuStore = cur === eu;
    if (!isUsaStore && !isEuStore) {
      if (log) log.collapse({ cur, eu, usa, isUsaStore, isEuStore }, 'Store redirect skip (unknown store)', 'warning');
      if (onDone) onDone();
      return;
    }
    if (log) log.collapse({ cur, eu, usa, isUsaStore, isEuStore }, 'Store redirect fetching geo', 'info');
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (this.readyState !== 4) return;
      if (this.status !== 200) {
        if (log) log.collapse({ status: this.status, statusText: this.statusText }, 'Store redirect geo XHR error', 'error');
        if (onDone) onDone();
        return;
      }
      try {
        const r = JSON.parse(this.responseText);
        const cc = r.CountryCode ? String(r.CountryCode).toUpperCase() : '';
        if (r.status !== 'success' || !r.CountryCode) {
          if (log) log.collapse({ status: r.status, CountryCode: r.CountryCode, cc }, 'Store redirect geo bad response', 'warning');
          if (onDone) onDone();
          return;
        }
        if (applyStoreRedirectForCountry(cc, cfg, isUsaStore, isEuStore)) return;
      } catch (e) {
        if (log) log.collapse({ err: String(e) }, 'Store redirect geo parse error', 'error');
      }
      if (onDone) onDone();
    };
    xhr.open('GET', 'https://apip.cc/json', true);
    xhr.send();
  }

  // ===================== First-visit geo market + language (EU only) =====================
  function initGeoLocalization() {
    if (shouldSkipEuLocalization()) {
      if (log) log.collapse({ action: 'skip geo localization (design mode or bot)' }, 'Geo localization skip', 'info');
      return;
    }
    if (!getLocalizationLanguages().length) {
      if (log) log.collapse({}, 'Geo localization skip (no localizationLanguages)', 'info');
      return;
    }
    if (getCookie('RedirectedFirstTime') === '1') {
      if (log) log.collapse({ RedirectedFirstTime: '1' }, 'Geo localization skip (already redirected)', 'info');
      return;
    }

    // Shopify already geo-detects the market country server-side (localization.country).
    // Use it directly and skip the flaky external IP lookup when present.
    const serverCountry = getCurrentCountryCode();
    if (serverCountry) {
      if (log) log.collapse({ serverCountry }, 'Geo localization using server country', 'info');
      applyGeoLocalization(serverCountry);
      return;
    }

    if (log) log.collapse({}, 'Geo localization fetching', 'info');
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (this.readyState != 4) return;
      if (this.status != 200) {
        if (log) log.collapse({ status: this.status }, 'Geo localization XHR error → defaults', 'error');
        applyGeoLocalization('');
        return;
      }
      try {
        const response = JSON.parse(this.responseText);
        if (response.status !== 'success') {
          if (log) log.collapse({ message: response.message }, 'Geo localization query failed → defaults', 'error');
          applyGeoLocalization('');
          return;
        }
        if (shouldSkipEuLocalization()) return;
        const cc = response.CountryCode ? String(response.CountryCode).toUpperCase().trim() : '';
        applyGeoLocalization(cc);
      } catch (e) {
        if (log) log.collapse({ err: String(e) }, 'Geo localization parse error', 'error');
      }
    };
    xhr.open('GET', 'https://apip.cc/json', true);
    xhr.send();
  }

  // ===================== Enforce User's Language Choice (EU only) =====================
  function enforceUserLanguageChoice() {
    if (shouldSkipEuLocalization()) {
      if (log) log.collapse({ action: 'skip enforce language (design mode or bot)' }, 'Enforce language skip', 'info');
      return;
    }

    const userSelectedLanguage = getCookie('userSelectedLanguage');
    if (!userSelectedLanguage) {
      if (log) log.collapse({ hasUserPref: false }, 'Enforce language → geo localization', 'info');
      initGeoLocalization();
      return;
    }

    const currentLanguage = getCurrentLanguageFromPath();
    const defaultIso = getDefaultLocaleIso();
    const normalizedUserLang = normalizeLocaleBase(userSelectedLanguage || defaultIso);
    const normalizedCurrentLang = normalizeLocaleBase(currentLanguage || defaultIso);

    if (normalizedUserLang !== normalizedCurrentLang) {
      if (!isLocaleAvailableOnStore(normalizedUserLang)) {
        if (log) log.collapse({ user: normalizedUserLang }, 'Enforce language skip (locale not on store)', 'warning');
        return;
      }
      let alreadyTried = false;
      try { alreadyTried = sessionStorage.getItem('langEnforced') === '1'; } catch (e) {}
      if (alreadyTried) {
        if (log) log.collapse({ user: normalizedUserLang, current: normalizedCurrentLang }, 'Enforce language skip (already tried this session)', 'warning');
        return;
      }
      if (log) {
        log.collapse(
          { user: normalizedUserLang, current: normalizedCurrentLang, action: 'form submit', country: getCurrentCountryCode() },
          'Enforce language',
          'info'
        );
      }
      try { sessionStorage.setItem('langEnforced', '1'); } catch (e) {}
      submitLocalizationForm(normalizedUserLang, getCurrentCountryCode(), true);
    }
  }

  // Initialize: store redirect always (USA+EU); market/language EU-only via runEuOnly
  function runEuOnly() {
    if (log) log.collapse({ localizationEnabled: !!window.localizationEnabled }, 'runEuOnly', 'info');
    if (!window.localizationEnabled) return;
    enforceUserLanguageChoice();
  }

  const hasStoreRedirect = !!(window.localeRedirect && window.localeRedirect.euStoreId && window.localeRedirect.usaStoreId);
  if (log) log.collapse({ hasStoreRedirect, branch: hasStoreRedirect ? 'initStoreRedirect→runEuOnly' : 'runEuOnly only' }, 'Localization init branch', 'info');
  if (hasStoreRedirect) {
    initStoreRedirect(runEuOnly);
  } else {
    runEuOnly();
  }
  preserveRedirectOffOnLinks();
});
